
import { AiProviderId, ChatMessage } from './types';

const KEY_PREFIX = 'wp_ai_key_';
const HISTORY_PREFIX = 'wp_ai_hist_';

export const getApiKey = (provider: AiProviderId): string => {
  if (typeof window === 'undefined') return '';
  return localStorage.getItem(`${KEY_PREFIX}${provider}`) || '';
};

export const setApiKey = (provider: AiProviderId, key: string) => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(`${KEY_PREFIX}${provider}`, key);
};

export const getBaseUrl = (): string => {
  if (typeof window === 'undefined') return '';
  return localStorage.getItem(`${KEY_PREFIX}custom_url`) || '';
};

export const setBaseUrl = (url: string) => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(`${KEY_PREFIX}custom_url`, url);
};

export const getChatHistory = (weddingId: string): ChatMessage[] => {
  if (typeof window === 'undefined' || !weddingId) return [];
  try {
    const raw = localStorage.getItem(`${HISTORY_PREFIX}${weddingId}`);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const saveChatHistory = (weddingId: string, messages: ChatMessage[]) => {
  if (typeof window === 'undefined' || !weddingId) return;
  // Keep last 50 messages to save space
  const trimmed = messages.slice(-50);
  localStorage.setItem(`${HISTORY_PREFIX}${weddingId}`, JSON.stringify(trimmed));
};

export const clearChatHistory = (weddingId: string) => {
  if (typeof window === 'undefined' || !weddingId) return;
  localStorage.removeItem(`${HISTORY_PREFIX}${weddingId}`);
};
